<template>
  <v-menu
    ref="menu"
    v-model="isActive"
    :close-on-content-click="false"
    :content-class="$vnode.data.staticClass"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    :nudge-top="110"
    max-width="290px"
    min-width="290px"
    @update:return-value="onUpdate(model)"
  >
    <template #activator="{ on, attrs }">
      <slot name="input" :on="on" :attrs="attrs">
        <BTextField
          ref="input"
          v-bind="Object.assign({}, attrs, $attrs)"
          :value="formattedTime"
          :skeleton="skeleton"
          :loading="loading"
          :prepend-inner-icon="icon"
          autocomplete="off"
          :name="name"
          readonly
          :disabled="disabled"
          :class="$vnode.data.staticClass"
          v-on="Object.assign({}, on, listeners)"
          @click="onClick"
          @click:clear="onClear"
          @focus="focus"
        >
          <template v-for="(_, key) in $slots" #[key]>
            <slot :name="key" />
          </template>

          <template v-for="(_, key) in $scopedSlots" #[key]="props">
            <slot v-bind="props" :name="key" />
          </template>
        </BTextField>
      </slot>
    </template>

    <v-time-picker
      v-model="modelTimePicker"
      format="24hr"
      scrollable
      @input="onInputTimePicker"
      @click:minute="onMinuteClick"
    />

    <slot name="after" />

    <template v-if="withButtons">
      <v-spacer />
      <div :class="buttonsClass">
        <v-btn v-if="withButtons" text @click="onCancel" v-text="'Отмена'" />
        <v-btn v-if="withButtons" depressed @click="onSave" v-text="'Изменить'" />
      </div>
    </template>
  </v-menu>
</template>

<script>
import moment from 'moment/moment'
import uniqueId from 'lodash/uniqueId'
import { dateFormatterIgnoreTz } from '@/helpers/dateFormatter'
import BTextField from './BTextField.vue'


const TIME_FORMAT = 'HH:mm'

export default {
  name: 'BTextFieldTime',
  inject: ['$validator'],
  components: {
    BTextField,
  },
  inheritAttrs: false,
  props: {
    value: null,
    disabled: Boolean,
    skeleton: Boolean,
    withButtons: Boolean,
    loading: Boolean,
    icon: {
      type: String,
      default: 'mdi-clock-outline',
    },
    name: {
      type: String,
      default: () => uniqueId('b-text-field-time-'),
    },
  },
  data() {
    const listeners = { ...this.$listeners }
    delete listeners.input
    const value = this.value?.includes('.') ? this.value.split('.').reverse().join('-') : this.value

    return {
      isActive: false,
      model: value,
      modelTimePicker: value,
      listeners,
    }
  },
  computed: {
    formattedTime() {
      return this.model
    },
    buttonsClass() {
      return { 'v-picker-actions': true, 'justify-center': !this.withButtons }
    },
  },
  methods: {
    focus() {
      this.isActive = true
    },
    isValueCorrect(value = this.value) {
      return moment(value, TIME_FORMAT).isValid()
    },
    onUpdate(newValue) {
      if (moment(newValue, TIME_FORMAT).isValid()) {
        this.modelTimePicker = newValue
      }

      if (newValue === this.value) {
        return
      }

      this.model = newValue || null
      this.$emit('input', newValue)
    },
    onClear() {
      this.onUpdate(null)
    },
    onInputTimePicker(time) {
      if (!this.withButtons) this.onUpdate(time)
    },
    onMinuteClick() {
      if (!this.withButtons) this.onSave()
    },
    async onClick() {
      this.isActive = true
      await this.$nextTick()
      this.isActive = true
      await new Promise((resolve) => setTimeout(resolve, 0))
      this.isActive = true
    },
    onSave() {
      this.isActive = false
      this.model = this.modelTimePicker
      this.$refs.menu.save(this.modelTimePicker)
    },
    onCancel() {
      this.isActive = false
      this.modelTimePicker = dateFormatterIgnoreTz(this.model, TIME_FORMAT)
    },
  },
}
</script>

<style lang="scss">
$bgWhite: #a6b9dc;

// Это из-за того, что компонент используется в LKLayout, который (внезапно) не использует v-app,
// и primary цвет не подтягивается
.v-picker__title {
  background-color: $color-primary;
}

.v-time-picker-clock__hand {
  background-color: $color-accent;
}

.v-time-picker-clock__item--active {
  background-color: $color-accent;
}

.v-picker-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem;
  background: $bgWhite;

  &.justify-center {
    justify-content: center;
  }
}

.v-date-picker-table .v-btn.v-btn--active {
  color: $bgWhite !important;
}
</style>
